import React from "react";
import type { Theme } from "@material-ui/core";
import { DialogTitle as MDialogTitle, Typography, makeStyles } from "@material-ui/core";

export type DialogTitleProps = {
    subTitle?: string;
    subTitle2?: string;
    title: string;
};

const useStyles = makeStyles((theme: Theme) => ({
    subTitle: {
        marginTop: theme.spacing(1),
    },
    subTitle2: {
        "&::before": {
            content: "''",
            padding: theme.spacing(1),
        },
    },
}));

export const DialogTitle = (props: DialogTitleProps) => {
    const { subTitle, subTitle2, title } = props;

    const classes = useStyles();

    return (
        <MDialogTitle disableTypography>
            <Typography variant="h2">{title}</Typography>
            {subTitle && (
                <Typography variant="subtitle1" className={classes.subTitle}>
                    {subTitle}
                    {subTitle2 && (
                        <Typography variant="body2" className={classes.subTitle2}>
                            {subTitle2}
                        </Typography>
                    )}
                </Typography>
            )}
        </MDialogTitle>
    );
};
